import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

import { SPACING_REGULAR, SPACING_UNIT } from '../../constant/spacing';
import { gridLayoutContainer, gridLayoutItem } from '../../styleUtility/gridLayout';
import DummyContent from '../primitive/DummyContent';

export interface Props {
  className?: string;
}

const DummyOfferDetail = ({ className }: ClassAttributes<HTMLElement> & Props) => {
  return (
    <Root className={className}>
      <ProjectId />
      <Title />

      <Organization />

      <ProjectTypeValue />
    </Root>
  );
};

const rootStyle = [
  gridLayoutContainer({
    columns: ['auto', '1fr', 'auto'],
    rows: ['auto', 'auto'],
    areas: [
      ['projectId', 'title', 'projectType'],
      ['.', 'organization', 'organization'],
    ],
    alignItems: 'center',
  }),
  { padding: SPACING_REGULAR },
];

const Root = styled('div')(rootStyle);

const ProjectId = styled(DummyContent)(gridLayoutItem('projectId', { justifySelf: 'flex-start' }), {
  wordWrap: 'break-word',
  wordBreak: 'break-word' as any,
  marginBottom: SPACING_UNIT,
  marginRight: SPACING_UNIT,
});

const Title = styled(DummyContent)(gridLayoutItem('title', { justifySelf: 'flex-start' }), {
  wordWrap: 'break-word',
  wordBreak: 'break-word' as any,
  marginBottom: SPACING_UNIT,
});

const ProjectTypeValue = styled(DummyContent, {})(gridLayoutItem('projectType'), {
  paddingLeft: SPACING_REGULAR,
  textAlign: 'right',
});

const Organization = styled(DummyContent)({
  ...gridLayoutItem('organization'),
});

export default DummyOfferDetail;
